import { Routes } from '@angular/router';
import { GlobalNavigationComponent } from './pages/global/global.navigation';
import { routeGuard } from './guards/route.guard';
import { registrationGuard } from './guards/registration.guard';
import { loginGuard } from './guards/login.guard';
import { GetCareBaseComponent } from './pages/get-care/get-care-base.component';
import { primeRoutes } from './prime/prime.routes';
import { registrationRoutes } from './pages/registration/registration.routes';
import { InviteRoutes } from './pages/account/invite/invite.routes';
import { primeGuard } from './guards/prime.guard';
import { accountRoutes } from './pages/account/account.routes';
import { getCareRoutes } from './pages/get-care/get-care.routes';
import { HomeBaseComponent } from './pages/home/home-base.component';
import { weightLossRoutes } from './pages/weight-loss/weight-loss.routes';
import { vitalsChcekerRoutes } from './pages/vital-checker/vitals-checker.routes';
import { visitSummaryRoutes } from './pages/post-visit-summary/visit-summary.routes';
import { monthlyCheckinRoutes } from './pages/monthly-checkin/monthly-checkin.routes';
import { paymentSubscriptionRoutes } from './pages/payment-subscription/payment-subscription.routes';
import { programRoutes } from './features/program-hub/program.routes';

export const routes: Routes = [
  {
    path: 'invite/accept/:id',
    loadComponent: () =>
      import('./pages/account/invite/accept-request/accept-request.page').then((m) => m.AcceptRequestPage),
  },
  {
    path: 'subscription/:id',
    canActivate: [routeGuard, registrationGuard],
    children: paymentSubscriptionRoutes,
  },
  {
    path: 'patient-transfer-access',
    loadComponent: () =>
      import('./pages/account/connected-accounts/accept-transfer/accept-transfer.page').then(
        (m) => m.AcceptTransferAccessPage,
      ),
  },
  {
    path: 'patient-transfer-access/incorrect-dob',
    loadComponent: () =>
      import('./pages/account/connected-accounts/incorrect-dob/incorrect-dob.page').then((m) => m.IncorrectDobPage),
  },
  {
    path: 'registration',
    canActivate: [routeGuard],
    loadComponent: () => import('./pages/registration/registration.page').then((m) => m.RegistrationPage),
    children: registrationRoutes,
  },
  {
    path: 'program',
    canActivate: [routeGuard, registrationGuard],
    children: programRoutes,
  },
  {
    path: 'weight-loss',
    canActivate: [routeGuard, registrationGuard],
    loadComponent: () => import('./pages/weight-loss/weight-loss.page').then((m) => m.WeightLossPage),
    children: weightLossRoutes,
  },
  {
    path: 'post-visit-summary/:id',
    canActivate: [routeGuard, registrationGuard],
    loadComponent: () => import('./pages/post-visit-summary/visit-summary.page').then((m) => m.VisitSummaryPage),
    children: visitSummaryRoutes,
  },
  {
    path: 'monthly-checkin/:id',
    canActivate: [routeGuard, registrationGuard],
    loadComponent: () => import('./pages/monthly-checkin/monthly-checkin.page').then((m) => m.MonthlyCheckinPage),
    children: monthlyCheckinRoutes,
  },
  {
    path: '',
    component: GlobalNavigationComponent,
    canActivate: [routeGuard, registrationGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
        data: {
          background: 'assets/splash_bck.jpg',
        },
      },
      {
        path: 'home',
        component: HomeBaseComponent,
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/home/home.page').then((m) => m.HomePage),
            data: {
              background: 'assets/splash_bck.jpg',
            },
          },
          {
            path: 'prime-onboarding',
            canActivate: [primeGuard],
            loadComponent: () => import('./pages/get-care/get-care-base.component').then((m) => m.GetCareBaseComponent),
            children: primeRoutes,
          },
        ],
      },
      {
        path: 'checkout',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/checkout/checkout.page').then((m) => m.CheckoutPage),
          },
          {
            path: 'payment-confirmation',
            pathMatch: 'full',
            loadComponent: () =>
              import('./pages/checkout/payment-confirmation/payment-confirmation.page').then(
                (m) => m.PaymentConfirmationPage,
              ),
          },
        ],
      },
      {
        path: 'get-care',
        loadComponent: () => import('./pages/get-care/get-care.page').then((m) => m.GetCarePage),
        children: getCareRoutes,
      },
      {
        path: 'vitals-checker',
        children: vitalsChcekerRoutes,
        loadComponent: () => import('./pages/vital-checker/vitals-checker.page').then((m) => m.VitalsCheckerPage),
      },
      {
        path: 'location',
        component: GetCareBaseComponent,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/get-care/in-person/location-picker/location-picker.page').then(
                (m) => m.LocationPickerPage,
              ),
            data: {
              background: 'assets/splash_bck.jpg',
            },
          },
          {
            path: 'account',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./pages/get-care/select-account/select-account.page').then((m) => m.SelectAccountPage),
              },
              {
                path: 'invite',
                loadComponent: () => import('./pages/account/invite/invite.page').then((m) => m.InvitePage),
                children: InviteRoutes,
              },
            ],
          },
          {
            path: 'time-picker',
            loadComponent: () =>
              import('./pages/get-care/in-person/time-picker/time-picker.page').then((m) => m.TimePickerPage),
          },
          {
            path: 'review',
            loadComponent: () =>
              import('./pages/get-care/schedule-review/schedule-review.page').then((m) => m.ScheduleReviewPage),
          },
          {
            path: 'wellness-clinics',
            loadComponent: () =>
              import('./pages/get-care/in-person/wellness-clinics/wellness-clinics.page').then(
                (m) => m.WellnessClinicsPage,
              ),
          },
        ],
      },
      {
        path: 'account',
        loadComponent: () => import('./pages/account/account.page').then((m) => m.AccountPage),
        children: accountRoutes,
      },
    ],
  },
  {
    path: 'login',
    children: [
      {
        path: '',
        canActivate: [loginGuard],
        loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
        data: {
          background: 'assets/splash_bck.jpg',
        },
      },
      {
        path: 'login-confirmation',
        canActivate: [registrationGuard],
        loadComponent: () =>
          import('./pages/login/login-confirmation/login-confirmation.page').then((m) => m.LoginConfirmationPage),
        data: {
          background: 'assets/splash_bck.jpg',
        },
      },
    ],
  },
  {
    path: 'verify',
    loadComponent: () => import('./pages/login/verify/verify.page').then((m) => m.VerifyPage),
  },
  {
    path: '404',
    canActivate: [routeGuard, registrationGuard],
    loadComponent: () => import('./pages/404/not-found.page').then((m) => m.NotFoundPage),
  },
  {
    path: ':hash',
    loadComponent: () => import('./pages/link-shortening/link-shortening.page').then((m) => m.LinkShorteningPage),
  },
  {
    path: '**',
    redirectTo: '/404',
  },
  {
    path: 'vital-checker',
    loadComponent: () =>
      import('./pages/vital-checker/measurement/vitals-measurement.page').then((m) => m.VitalsMeasurementPage),
  },
];
